import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Approximate sticky-header offset — announcement bar (~30px) + header (~100px)
const HEADER_OFFSET = 140;

/**
 * ScrollToTop — resets scroll on route change for PUSH/REPLACE navigations.
 * Handles anchors (#hash) with a retry loop and header offset. For POP navs
 * without a hash, leaves browser-native scroll restoration alone.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
          window.scrollTo({ top: Math.max(0, y), left: 0, behavior: "auto" });
          // Keep observing briefly for post-mount layout shifts (images loading)
          if (++attempts < 8) setTimeout(tryScroll, 80);
          return;
        }
        if (++attempts < 15) setTimeout(tryScroll, 60);
      };
      tryScroll();
      return;
    }
    if (navType === "POP") return; // browser restores non-hash POP navs
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, navType]);

  return null;
}
